"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userMiniProfileVariant = exports.toggleNotificationValidatingProfile = exports.showSecurityCentral = exports.showPhoneNumberSecurityModal = exports.showContentModRatingTip = exports.showAskProfileVerificationButton = exports.sendPhoneNumberSecurityModal = exports.isInitialMessageEnabled = exports.isFrontDatadog = exports.isChatTabsFavorite = exports.isChatTabsBuyerSeller = exports.isChatSecurity = exports.isChatFavorite = exports.chatModBannerVariants = exports.alreadySoldTipTextVariant = void 0;
var _reselect = require("reselect");
// ====================================================================
// Select data from * state *
// ====================================================================

var _getExperiments = function _getExperiments(_ref) {
  var variants = _ref.variants;
  return variants;
};
var _getVariant = function _getVariant(experiment) {
  return (0, _reselect.createSelector)(_getExperiments, function (experiments) {
    return (experiments || {})[experiment] || '';
  });
};

// ====================================================================
// Selectors
// ====================================================================

var userMiniProfileVariant = exports.userMiniProfileVariant = (0, _reselect.createSelector)(_getVariant('mini-perfi-no-chatbox'), function (variant) {
  return variant;
});
var alreadySoldTipTextVariant = exports.alreadySoldTipTextVariant = (0, _reselect.createSelector)(_getVariant('mes-965-already-sold-hackday'), function (variant) {
  return variant;
});
var toggleNotificationValidatingProfile = exports.toggleNotificationValidatingProfile = (0, _reselect.createSelector)(_getVariant('toggle-notification-validating-profile'), function (variant) {
  return variant === 'enabled';
});
var chatModBannerVariants = exports.chatModBannerVariants = (0, _reselect.createSelector)(_getExperiments, function (experiments) {
  try {
    return Object.fromEntries(Object.entries(experiments).filter(function (keyValue) {
      return typeof keyValue[0] === 'string' && keyValue[0].startsWith('chatmod-banner');
    }));
  } catch (_) {
    return {};
  }
});
var showAskProfileVerificationButton = exports.showAskProfileVerificationButton = (0, _reselect.createSelector)(_getVariant('show-ask-profile-verification-button'), function (variant) {
  return variant === 'enabled';
});
var showPhoneNumberSecurityModal = exports.showPhoneNumberSecurityModal = (0, _reselect.createSelector)(_getVariant('contentmod-exit-modal-chat'), function (variant) {
  return variant;
});
var sendPhoneNumberSecurityModal = exports.sendPhoneNumberSecurityModal = (0, _reselect.createSelector)(_getVariant('chatmod-send-phone-modal'), function (variant) {
  return variant;
});
var isChatTabsBuyerSeller = exports.isChatTabsBuyerSeller = (0, _reselect.createSelector)(_getVariant('mes-chat-tabs-enabled'), function (variant) {
  return variant === 'bsrtabs';
});
var isChatTabsFavorite = exports.isChatTabsFavorite = (0, _reselect.createSelector)(_getVariant('mes-chat-tabs-enabled'), function (variant) {
  return variant === 'favtabs';
});
var isChatSecurity = exports.isChatSecurity = (0, _reselect.createSelector)(_getVariant('mes-chat-security-tip-box'), function (variant) {
  return variant === 'enabled';
});
var isChatFavorite = exports.isChatFavorite = (0, _reselect.createSelector)(_getVariant('mes-favorite-feature'), function (variant) {
  return variant === 'enabled';
});
var showContentModRatingTip = exports.showContentModRatingTip = (0, _reselect.createSelector)(_getVariant('cnt-rating'), function (variant) {
  return variant;
});
var isFrontDatadog = exports.isFrontDatadog = (0, _reselect.createSelector)(_getVariant('mes-dtadog'), function (variant) {
  return variant === 'enabled';
});
var showSecurityCentral = exports.showSecurityCentral = (0, _reselect.createSelector)(_getVariant('cnt-scchat'), function (variant) {
  return variant;
});
var isInitialMessageEnabled = exports.isInitialMessageEnabled = (0, _reselect.createSelector)(_getVariant('con-inimes'), function (variant) {
  return variant === 'A';
});